// extracted by mini-css-extract-plugin
module.exports = {"riskDetailTr":"RiskProfileDetail_riskDetailTr__2M7CL","spin":"RiskProfileDetail_spin__3OPeO"};